import styled from 'styled-components';

export const Container = styled.div<{ backgroundColor: string; brand: string }>`
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: 16px;
  padding: 9px 0;
  position: relative;
  overflow: ${({ brand }) => (brand === 'talkspace' ? 'hidden' : 'visible')};
  width: 100%;
  min-height: 440px;
`;

export const TestimonialsWrapper = styled.div<{ brand: string }>`
  display: flex;
  flex-direction: ${({ brand }) => (brand === 'teladoc' ? 'column' : 'row')};
  gap: 16px;
  align-items: flex-start;
  justify-content: flex-start;
  padding: ${({ brand }) => (brand === 'teladoc' ? '24px 24px 24px 32px' : '24px')};

  @media (min-width: 768px) {
    flex-direction: row;
    width: ${({ brand }) => (brand === 'teladoc' ? '669px' : '100%')};
  }
`;

export const Quote = styled.div<{ background: string; padding: string }>`
  background: ${({ background }) => background};
  border-radius: 8px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: ${({ padding }) => padding};
`;

export const QuoteText = styled.div<{ color: string }>`
  color: ${({ color }) => color};
  text-align: left;
  font-size: 18px;
  line-height: 140%;
  font-weight: 400;
  padding: 24px;
`;

export const BoldText = styled.span`
  font-family: 'Gelica';
  font-weight: 500;
  font-size: 18px;
  line-height: 140%;
`;

export const LightText = styled.span`
  display: inline-block;
  font-size: 16px;
  letter-spacing: -0.011em;
  margin-top: 0.5rem;
`;

export const ReplayButton = styled.button<{ brand: string }>`
  position: ${({ brand }) => (brand === 'teladoc' ? 'absolute' : 'static')};
  bottom: ${({ brand }) => (brand === 'teladoc' ? '0.5rem' : 'auto')};
  left: ${({ brand }) => (brand === 'teladoc' ? '12px' : 'auto')};
  width: 96px;
  height: 32px;
  border-radius: 4px;
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.5);
  }
`;

export const RepeatImage = styled.img`
  width: 16px;
  height: 16px;
`;

export const CopyText = styled.div`
  color: #2f2f52;
  font-size: 14px;
  line-height: 16px;
  font-weight: 400;
`;

export const LilGuy = styled.div`
  position: absolute;
  bottom: 0;
  left: 110px;
  z-index: 1;
  pointer-events: none;

  img {
    width: 236px;
    display: block;
    margin: 0 auto;
  }
`;

export const EllipseWrapper = styled.div`
  position: absolute;
  top: 60%;
  left: 38%;
  transform: translate(-80%, -60%);
  width: 45%;
  height: 75%;
  z-index: 1;
  pointer-events: none;
`;

export const Ellipse = styled.div<{ left: number; top: number; color?: string }>`
  background: ${({ color }) => color};
  border-radius: 50%;
  width: 149.58px;
  height: 178.13px;
  position: absolute;
  transform: rotate(-19.273deg);
  left: ${({ left }) => `${left}px`};
  top: ${({ top }) => `${top}px`};
`;
